<div [id]="'page' + pageNum" class="exportPage12" [ngClass]="getClasses()">
  <ng-content></ng-content>
</div>
